export const FETCH_TRIP_CRUD_LOAD_INIT_ACTION =
  "FETCH_TRIP_CRUD_LOAD_INIT_ACTION";
export const FETCH_TRIP_CRUD_LOAD_SUCCESS_ACTION =
  FETCH_TRIP_CRUD_LOAD_INIT_ACTION + "_SUCCESS";
export const FETCH_TRIP_CRUD_LOAD_FAIL_ACTION =
  FETCH_TRIP_CRUD_LOAD_INIT_ACTION + "_ERROR";

export const FETCH_LOAD_DRIVER_INIT_ACTION = "FETCH_LOAD_DRIVER_INIT_ACTION";
export const FETCH_LOAD_DRIVER_SUCCESS_ACTION =
  FETCH_LOAD_DRIVER_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_DRIVER_FAIL_ACTION =
  FETCH_LOAD_DRIVER_INIT_ACTION + "_ERROR";

export const FETCH_LOAD_VEHICLE_INIT_ACTION = "FETCH_LOAD_VEHICLE_INIT_ACTION";
export const FETCH_LOAD_VEHICLE_SUCCESS_ACTION =
  FETCH_LOAD_VEHICLE_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_VEHICLE_FAIL_ACTION =
  FETCH_LOAD_VEHICLE_INIT_ACTION + "_ERROR";

export const FETCH_UPDATE_SINGLE_LOAD_DATA_ACTION =
  "FETCH_UPDATE_SINGLE_LOAD_DATA_ACTION";

export const UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION =
  "UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION";
export const UPDATE_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION =
  UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION + "_SUCCESS";
export const UPDATE_TRIP_CRUD_LOAD_FAIL_ACTION =
  UPDATE_TRIP_PLAN_CRUD_LOAD_INIT_ACTION + "_ERROR";

export const SELECTED_LOAD_INIT_ACTION = "SELECTED_LOAD_INIT_ACTION";
export const SELECTED_LOAD_SUCCESS_ACTION =
  SELECTED_LOAD_INIT_ACTION + "_SUCCESS";
export const SELECTED_LOAD_FAIL_ACTION = SELECTED_LOAD_INIT_ACTION + "_ERROR";

export const DELETE_SELECTED_LOAD_INIT_ACTION =
  "DELETE_SELECTED_LOAD_INIT_ACTION";

export const UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION =
  "UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION";
export const UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_SUCCESS_ACTION =
  UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION + "_SUCCESS";
export const UPDATE_PLANNED_TRIP_CRUD_LOAD_FAIL_ACTION =
  UPDATE_PLANNED_TRIP_PLAN_CRUD_LOAD_INIT_ACTION + "_ERROR";

export const FETCH_TRIP_PLAN_BY_ID_INIT_ACTION =
  "FETCH_TRIP_PLAN_BY_ID_INIT_ACTION";
export const FETCH_TRIP_PLAN_BY_ID_SUCCESS_ACTION =
  FETCH_TRIP_PLAN_BY_ID_INIT_ACTION + "_SUCCESS";
export const FETCH_TRIP_PLAN_BY_ID_FAIL_ACTION =
  FETCH_TRIP_PLAN_BY_ID_INIT_ACTION + "_ERROR";

export const FETCH_LOAD_BY_IDS_INIT_ACTION = "FETCH_LOAD_BY_IDS_INIT_ACTION";
export const FETCH_LOAD_BY_IDS_INIT_SUCCESS_ACTION =
  FETCH_LOAD_BY_IDS_INIT_ACTION + "_SUCCESS";
export const FETCH_LOAD_BY_IDS_FAIL_ACTION =
  FETCH_LOAD_BY_IDS_INIT_ACTION + "_ERROR";

export const UPDATE_TRIP_PLAN_PROCESSING_INIT_ACTION =
  "UPDATE_TRIP_PLAN_PROCESSING_INIT_ACTION";

export const DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION =
  "DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION";
export const DELETE_PLANNED_SELECTED_TRIP_SUCCESS_ACTION =
  DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION + "_SUCCESS";
export const DELETE_PLANNED_SELECTED_TRIP_FAIL_ACTION =
  DELETE_PLANNED_SELECTED_TRIP_INIT_ACTION + "_ERROR";

export const FETCH_VEHICLE_SUB_CAT_INIT_ACTION =
  "FETCH_VEHICLE_SUB_CAT_INIT_ACTION";
export const FETCH_VEHICLE_SUB_CAT_INIT_SUCCESS_ACTION =
  FETCH_VEHICLE_SUB_CAT_INIT_ACTION + "_SUCCESS";
export const FETCH_VEHICLE_SUB_CAT_FAIL_ACTION =
  FETCH_VEHICLE_SUB_CAT_INIT_ACTION + "_ERROR";

export const CREATE_BID_INIT_ACTION = "CREATE_BID_INIT_ACTION";
export const CREATE_BID_INIT_ACTION_SUCCESS_ACTION =
  CREATE_BID_INIT_ACTION + "_SUCCESS";
export const CREATE_BID_INIT_ACTION_FAIL_ACTION =
  CREATE_BID_INIT_ACTION + "_ERROR";

export const UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN =
  "UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN";
export const UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN_SUCCESS_ACTION =
  UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN + "_SUCCESS";
export const UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN_FAIL_ACTION =
  UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN + "_ERROR";

export const FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN =
  "UPDATE_LOAD_BY_INIT_ACTION_TRIP_DESIGN";
export const FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN_SUCCESS_ACTION =
  FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN + "_SUCCESS";
export const FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN_FAIL_ACTION =
  FETCH_BID_BY_INIT_ACTION_TRIP_DESIGN + "_ERROR";

export const FETCH_PAYMNT_INIT_ACTION = "FETCH_PAYMNT_INIT_ACTION";
export const FETCH_PAYMNT_INIT_SUCCESS_ACTION =
  FETCH_PAYMNT_INIT_ACTION + "_SUCCESS";
export const FETCH_PAYMNT_INIT_FAIL_ACTION =
  FETCH_PAYMNT_INIT_ACTION + "_ERROR";

export const CLEAR_SELECTED_LIST = 'CLEAR_SELECTED_LIST'
